import React from 'react';
import { useMediaQuery } from '@mui/material';

const useDeviceType = ({ minWidth = 0, maxWidth = 1537 }) => {
    const isMobile = useMediaQuery('(max-width:640px)');//xs
    const isTablet = useMediaQuery('(min-width:641px) and (max-width:768px)');//sm
    const isLaptop = useMediaQuery('(min-width:769px) and (max-width:1024px)');//md
    const isDesktop = useMediaQuery('(min-width:1025px) and (max-width:1280px)');//lg
    const isExtraLarge = useMediaQuery('(min-width:1281px) and (max-width:1536px)');//xl
    const isDoubleExtraLarge = useMediaQuery('(min-width:1537px)');//2xl
    console.log(minWidth, "minWidth");
    console.log(maxWidth, "maxWidth");

    const isCustomDevice = useMediaQuery(`(min-width:${minWidth}px) and (max-width:${maxWidth}px)`);//custom device


    return ({
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
        isExtraLarge,
        isDoubleExtraLarge,
        isCustomDevice
    })
}

export default useDeviceType;
